import {
  constructApplications,
  constructLayoutEngine,
  constructRoutes,
} from 'single-spa-layout';
import { registerApplication, start } from 'single-spa';

import { RoutesConfig } from 'single-spa-layout/dist/types/isomorphic/constructRoutes';
import { applyBranchPreviewOverrides } from './applyBranchPreviewOverrides';
import axios from 'axios';

/**
 * Fetches the layout and routes file from the GCS bucket.
 */
const fetchLayoutAndRoutes = async (): Promise<RoutesConfig> => {
  const routesFilepath = process.env.IS_LOCAL
    ? 'https://na14.voc.qa-integration.p-44.com/layout-and-routes.json'
    : '/layout-and-routes.json';
  const { data } = await axios.get<RoutesConfig>(routesFilepath);
  return data;
};

const main = async () => {
  const routesConfig = await fetchLayoutAndRoutes();
  const routes = constructRoutes(routesConfig);
  const applications = constructApplications({
    routes,
    loadApp({ name }) {
      return System.import(name);
    },
  });
  const layoutEngine = constructLayoutEngine({ routes, applications });

  applications.forEach(registerApplication);
  layoutEngine.activate();
  start();
};

main();
applyBranchPreviewOverrides();
